import React, {useEffect, useState, useRef} from 'react';
import {Trans} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import {getSharingDetailsPopup} from '../../../../../../../../../actions/sharingDetailsActions';
import Loader from '../../../../../../../../components/sprite/components/loader';
import Label from '../../../label';
import Button from '../../../../../../../../components/button';
import NewLabelsLoading from "../../../new-labels-loading";
import {displayLabelSearch as setDisplayLabelSearch} from '../../../../../../../../../actions/contactsGroupItemActions';
import './index.css';

function ContactGroupBody () {
	const [scrollTop, setScrollTop] = useState(0);
	const [viewportHeight, setViewportHeight] = useState(0);
	const [totalGroups, setTotalGroups] = useState(0);

	const groupBodyRef = useRef(null);

	const findLabels = useSelector(state => state.contactsGroupItemReducer.findLabels);
	const enteredSearchValue = useSelector(state => state.contactsGroupItemReducer.getEnteredSearchValue);
	const allLabelsFetched = useSelector(state => state.contactsGroupItemReducer.allLabelsFetched);
	const displayLabelSearch = useSelector(state => state.contactsGroupItemReducer.displayLabelSearch);

	const dispatch = useDispatch();

	const rowHeight = 42;
	const amountRowsBuffered = 2;

	const handleResize = () => {
		if (groupBodyRef.current) {
			setViewportHeight(groupBodyRef.current.getBoundingClientRect().height);
		}
	};

	useEffect(() => {
		if(groupBodyRef.current){
			setViewportHeight(groupBodyRef.current.getBoundingClientRect().height);
			window.addEventListener('resize', handleResize);
		}

		return () => {
			window.removeEventListener('resize', handleResize);
		}
	}, []);


	useEffect(() => {
		if(findLabels){
			const countGroups = (groups) => {
				let count = 0;

				groups.forEach(group => {
					count += 1;
					if (group.childContactGroups) {
						count += countGroups(group.childContactGroups);
					}
				});

				return count;
			};

			const total = countGroups(findLabels.contactsGroups);
			setTotalGroups(total);
		}
	}, [findLabels]);

	const newLabelHandler = () => {
		dispatch(getSharingDetailsPopup([true, 'new_label']));
	};

	let indexStart = Math.max(
		Math.floor(scrollTop / rowHeight) - amountRowsBuffered,
		0
	);

	let indexEnd = Math.min(
		Math.ceil((scrollTop + viewportHeight) / rowHeight - 1) +
		amountRowsBuffered,
		totalGroups - 1
	);

	const update = (e) => {
		if(!displayLabelSearch){
			dispatch(setDisplayLabelSearch(true));
		}
		setScrollTop(e.target.scrollTop);
	};

	let labelIndex = 0;

	/*if(!findLabels){
		return (
			<div className="list-of-group-body"
				style={{
					display: 'block',
					lineHeight: 2.5,
					padding: '1rem',
					marginBottom: '0.5rem',
				}}
			>
				{viewportHeight}
				{
					Array(Math.ceil(viewportHeight / 60)).fill("").map( () => (
						<div style={{ display: 'flex', alignItems: 'center', gap: '1.2em', lineHeight: 1, marginBottom: '1em' }}>
							<Skeleton width={30} height={30} />
							<div style={{ flexGrow: 1 }}>
								<Skeleton height={30} />
							</div>
						</div>
					))
				}
			</div>
		)
	}*/

	return (
		<div ref={groupBodyRef} className={`list-of-group-body${!findLabels ? ' labels-pending' : ''}`} onScroll={ update }>
			{
				findLabels
				?
					<>
						<div
							style={{
								position: 'relative',
								height: findLabels.contactsGroups.length >= 0 && findLabels.contactsGroups.length <= 2 ? ((rowHeight * totalGroups) + 154) : (rowHeight * totalGroups),
								overflowX: 'hidden'
							}}
						>
							{
								!findLabels && <Loader/>
							}
							{
								findLabels !== null
								?
									findLabels.contactsGroups.length > 0
									?
										enteredSearchValue !== ''
										?
											findLabels.contactsGroups.map(contactsGroup => {
												if (contactsGroup.name.toLowerCase().includes(enteredSearchValue.toLowerCase())) {
													labelIndex = labelIndex + 1;
													return (
														<Label
															key={contactsGroup.id}
															id={contactsGroup.id}
															name={contactsGroup.name}
															status={contactsGroup.status}
															nbOfContact={contactsGroup.nbOfContact}
															permission={contactsGroup.permission}
															type={'contact'}
															sharingPreview={contactsGroup.sharingPreview}
															sharingNumber={contactsGroup.sharingNumber}
															ownerId={contactsGroup.ownerId}
															ownerName={contactsGroup.ownerName}
															rowStyle={{height: rowHeight, top: labelIndex * rowHeight - rowHeight}}
														/>
													)
												} else {
													return null;
												}
											})
										:
											findLabels.contactsGroups.slice(indexStart, indexEnd + 1).map(contactsGroup => {
												return (
													<Label
														key={contactsGroup.id}
														id={contactsGroup.id}
														name={contactsGroup.name}
														status={contactsGroup.status}
														nbOfContact={contactsGroup.nbOfContact}
														permission={contactsGroup.permission}
														type={'contact'}
														sharingPreview={contactsGroup.sharingPreview}
														sharingNumber={contactsGroup.sharingNumber}
														ownerId={contactsGroup.ownerId}
														ownerName={contactsGroup.ownerName}
														rowStyle={{height: rowHeight, top: contactsGroup.position * rowHeight - rowHeight}}
													/>
												)
											})
										:
										null
									:
									<Loader/>
							}
							{
								findLabels !== null
									?
									findLabels.contactsGroups.length >= 0 && findLabels.contactsGroups.length <= 2
										?
										<div className="text-center px-0 px-md-5 py-5" style={{position: 'relative', top: rowHeight * totalGroups}}>
											<p className={`${window.innerWidth > 991 ? 'lead ' : ''}text-nowrap`}>
												<Trans i18nKey="textIconSharedList" components={{
													btn: <Button className="btn-link px-1" onClick={newLabelHandler}/>,
													svg: <svg className="d-flex" width="21px" height="21px" viewBox="0 0 21 21"/>,
													path: <path fill="#090" d="M10.5,21C4.7,21,0,16.3,0,10.5C0,4.7,4.7,0,10.5,0C16.3,0,21,4.7,21,10.5
																C21,16.3,16.3,21,10.5,21z M10.5,1C5.2,1,1,5.2,1,10.5c0,5.3,4.3,9.5,9.5,9.5c5.3,0,9.5-4.3,9.5-9.5C20,5.2,15.8,1,10.5,1z
																M11.8,16.3H9.2v-4.5H4.7V9.2h4.5V4.7h2.6v4.5h4.5v2.6h-4.5V16.3z"/>
												}}/>

											</p>
										</div>
										:
										null
									:
									null
							}
						</div>
						{
							(findLabels.contactsGroups.length < findLabels.pages.totalRecords && !allLabelsFetched)
							&& <NewLabelsLoading labels={findLabels}/>
						}
					</>
				:
					Array(Math.ceil(viewportHeight / 60)).fill("").map( (value, index) => (
						<div key={index} style={{ display: 'flex', alignItems: 'center', gap: '1.2em', lineHeight: 1, marginBottom: '1em' }}>
							<Skeleton width={30} height={30} />
							<div style={{ flexGrow: 1 }}>
								<Skeleton height={30} />
							</div>
						</div>
					))
			}
		</div>
	)
}

export default ContactGroupBody;
